import { render, staticRenderFns } from "./SharetoClient.vue?vue&type=template&id=d0a478f2&scoped=true&"
import script from "./SharetoClient.vue?vue&type=script&lang=js&"
export * from "./SharetoClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a478f2",
  null
  
)

export default component.exports